<template>
  <div>
    <dialog-reset top='10vh' slotShow height="auto" width="1050px" title="异常处理" :visible.sync="earlyWarningShow" :zoomShow="false">
      <div class="max-div" v-loading="loading">
        <el-descriptions :column="2" border>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-time"></i>
              过车时间
            </template>
            {{ form.passTime }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-position"></i>
              图像位置
            </template>
            {{ imagePosition(camera) }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-truck"></i>
              车型
            </template>
            {{ form.trainType }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-s-order"></i>
              车号
            </template>
            <el-tag size="small">{{ form.trainNo }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-warning-outline"></i>
              问题类型
            </template>
            <el-button type="text" @click="addMarkers(form.problemList.length)" :disabled="disabled">增加标记</el-button>
            <div v-for="(item, index) in form.problemList" class="markers-list" :key="index"
              style="display: flex; align-items: center">
              <div class="key-div">
                <p>{{ item.problemSerial }}</p>
              </div>
              <div class="data-div" v-if="deptOptions.length > 0">
                <el-cascader v-model="item.threeClassCode" :options="deptOptions" placeholder="请选择异常标记类型" :disabled="disabled"
                  :props="{ value: 'id', label: 'name' }" style="width: 100%;"></el-cascader>
                <el-input type="text" placeholder="请输入备注" v-model="item.remark" :disabled="disabled" maxlength="30" show-word-limit
                  class="input"></el-input>
              </div>
              <div class="delete-div">
                <el-button type="text" @click="deleteMarkers(index)" :disabled="disabled">删除标记</el-button>
              </div>
            </div>
          </el-descriptions-item>
        </el-descriptions>

        <div class="resizable-div">
          <el-image class="image" :src="image" @error="imageError">
            <div slot="error" class="image-slot">
              <!--  异常图片直接不展示  -->
            </div>
          </el-image>
          <vue-draggable-resizable class="draggable" v-for="(item, index) in form.problemList" :key="`markers${index}`"
            :w="item.width" :h="item.height" :x="item.problemX1" :y="item.problemY1" @dragging="onDrag"
            @resizing="onResize" :parent="true" @activated="getIndex(index)"
            :class-name="item.dealStatus == 0 ? 'my-class' : 'my-class1'" :draggable="item.dealStatus == 0 && !disabled"
            :classNameHandle="disabled ? 'handleTwo' : item.dealStatus == 0 ? 'handle' : 'handleTwo'">
            <el-tag effect="dark" size="mini" :type="item.dealStatus == 0 ? 'danger' : 'success'"
              style="border-radius: 0; user-select: none">
              {{ item.problemSerial }}
            </el-tag>
          </vue-draggable-resizable>
        </div>
      </div>
      <span slot="dialog_footer">
        <el-button :loading="loading" @click="earlyWarningShow = false">取 消</el-button>
        <el-button :loading="loading" type="primary" @click="earlyWarningSave">确 定</el-button>
      </span>
    </dialog-reset>
  </div>
</template>

<script>
import "vue-draggable-resizable/dist/VueDraggableResizable.css";
import { earlyWarning, trainProblemTreeData, earlyWarningSave } from '@/api/handover-inspection/passing-manage'
import { isNull } from '@/util/util.js'
import {getSysConfig} from "@/util/util";

export default {
  computed: {
    imagePosition() {
      return function (camera) {
        switch (camera) {
          case 'A':
            return '北侧图像'
            break;
          case 'C':
            return '南侧图像'
            break;
          case 'B':
            return '顶部图像'
            break;
          default:
            break;
        }
      }
    }
  },
  data() {
    return {
      earlyWarningShow: false, //异常弹窗
      index: 0,//第几个标注
      deptOptions: [],//异常类型列表
      form: {},//异常信息
      problemSerialIndex: 0,//标注自定义长度【只能增，不能减去】
      deleteList: [],//删除的标记信息
      loading: false,//加载中
      image: '',//展示的图片
      camera: '', // 相机位置
      disabled: false,//图片是否加载失败
    };
  },
  methods: {
    // 打开弹窗
    openEarlyWarning(form, imgPosition) {
      this.deptOptions = []
      this.deleteList = []
      this.index = 0
      this.form = form
      this.earlyWarningShow = true;
      this.loading = true;
      this.disabled = false;
      const baseUrl = getSysConfig('CHECK_MINIO')
      this.getImageUrl(form[imgPosition].original.replace(baseUrl,''),'check').then(res => {
        this.image = res
      })
      console.log(form[imgPosition].original)
      this.camera = imgPosition === 'leftPath' ? 'A' : imgPosition === 'rightPath' ? 'C' : 'B'
      //获取异常信息
      earlyWarning({
        trainId: form.trainId,
        camera: this.camera,
        trainDetailId: form.id
      }).then(res => {
        this.form = res.data

        if (this.form.problemList.length > 0) {
          const lastNum = parseInt(this.form.problemList[this.form.problemList.length - 1].problemSerial.replace(this.camera, ''))
          this.problemSerialIndex = isNaN(lastNum) ? 0 : 1 + lastNum
        } else {
          this.problemSerialIndex = 0
        }
      }).then(() => {
        //获取异常类型
        trainProblemTreeData().then(res => {
          function buildTree(items) {
            let tree = [];
            let lookup = {}; // 用于快速查找节点的映射表

            // 初始化映射表
            items.forEach(item => {
              lookup[item.id] = { ...item, children: [] };
            });

            // 构建树
            items.forEach(item => {
              if (item.parent === "#") {
                // 顶级节点直接添加到树中
                tree.push(lookup[item.id]);
              } else {
                // 非顶级节点添加到其父节点的children数组中
                if (lookup[item.parent]) {
                  lookup[item.parent].children.push(lookup[item.id]);
                }
              }
            });

            return tree;
          }
          function removeEmptyChildren(nodes) {
            let list = nodes
            nodes.forEach(node => {
              if (isNull(node.children)) {
                delete node.children;
              }
              if (node.children) {
                removeEmptyChildren(node.children);
              }
            });
            return list
          }
          // 进行类型格式化
          this.deptOptions = removeEmptyChildren(buildTree(res.data))
          let idList = []
          function getThreeClassCode(id, list) {
            idList.unshift(id)
            let item = list.filter(nodes => {
              return nodes.id == id
            })
            if (item[0].parent != '#') {
              getThreeClassCode(item[0].parent, list)
            }
          }
          // 使用最低级的ID去拿所有的父id
          this.form.problemList.forEach(item => {
            idList = []
            getThreeClassCode(item.threeClassCode, res.data)
            item.threeClassCode = idList

            item.problemX1 = parseInt(item.problemX1 / 8)
            item.problemY1 = parseInt(item.problemY1 / 8)
            item.problemX2 = parseInt(item.problemX2 / 8)
            item.problemY2 = parseInt(item.problemY2 / 8)
            this.$set(item, 'width', parseInt(item.problemX2 - item.problemX1))
            this.$set(item, 'height', parseInt(item.problemY2 - item.problemY1))
          })
          this.loading = false;

          this.$forceUpdate()
        })
      })
    },
    // 提交异常
    earlyWarningSave() {
      if (this.form.problemList.length > 0) {
        if (isNull(this.form.problemList[this.form.problemList.length - 1].threeClassCode)) {
          this.$message({
            message: '请先选择异常标记类型',
            type: 'warning'
          });
          return
        }
      }
      if (this.form.problemList.filter(res => res.dealStatus == 0).length == 0 && this.deleteList.length == 0) {
        this.$message({
          message: '您暂无可提交的预警信息',
          type: 'warning'
        });
        return
      }

      this.loading = true;
      function getList(list) {
        return list.map(res => {
          let x = res.problemX1
          let y = res.problemY1
          return {
            ...res,
            ...{
              problemX2: parseInt((x + res.width) * 8),
              problemY2: parseInt((y + res.height) * 8),
              threeClassCode: res.threeClassCode[res.threeClassCode.length - 1],
              problemX1: parseInt(res.problemX1 * 8),
              problemY1: parseInt(res.problemY1 * 8)
            }
          }
        })
      }
      this.form.problemList = getList(this.form.problemList).filter(res => {
        return res.dealStatus == 0
      })

      this.form.problemList = this.form.problemList.concat(getList(this.deleteList))
      earlyWarningSave(this.form).then(res => {
        if (res.code == 200) {
          this.$message({
            message: '操作成功',
            type: 'success'
          });
          this.earlyWarningShow = false;
          this.loading = false;
          this.$emit('refreshEarlyWarning')
        }
      }).catch(() => {
        this.earlyWarningShow = false;
        this.loading = false;
      })
    },
    // 添加标记
    addMarkers(index) {
      if (index == 0) {

      } else if (isNull(this.form.problemList[index - 1].threeClassCode)) {
        this.$message({
          message: '请先选择异常标记类型',
          type: 'warning'
        });
        return
      }
      this.form.problemList.push({
        width: 100,
        height: 100,
        problemX1: 0,
        problemY1: 0,
        remark: null,
        dealStatus: 0,// 0 未处理 1已处理
        threeClassCode: null,
        problemSerial: `${this.camera}${this.problemSerialIndex}`
      });
      this.problemSerialIndex++
    },
    //删除标记
    deleteMarkers(index) {
      let data = this.form.problemList.splice(index, 1);
      if (data[0].id) {
        this.deleteList.push({
          ...data[0],
          delFlag: 1
        })
      }
    },
    //当前操作的是那个标记
    getIndex(index) {
      this.index = index;
    },
    //操作标记框
    onResize(x, y, width, height) {
      if (this.form.problemList[this.index].dealStatus == 1) {
        return
      }
      this.form.problemList[this.index].problemX1 = x;
      this.form.problemList[this.index].problemY1 = y;
      this.form.problemList[this.index].width = width;
      this.form.problemList[this.index].height = height;
    },
    // 拖拽标记框
    onDrag(x, y) {
      if (this.form.problemList[this.index].dealStatus == 1) {
        return
      }
      this.form.problemList[this.index].problemX1 = x;
      this.form.problemList[this.index].problemY1 = y;
    },
    //图片加载失败 禁止加标记
    imageError(){
      this.disabled = true
    }
  },
};
</script>

<style scoped lang='scss'>
::-webkit-scrollbar {
  display: none;
}

.max-div {
  width: 1000px;
  height: 500px;
  overflow: auto;



  .markers-list {
    width: 100%;
    display: flex;
    align-items: center;
    border-top: 1px solid #e6ebf5;

    .key-div {
      width: 50px;
      text-align: center;
    }

    .data-div {
      flex: 1;
      padding: 10px;
      border-left: 1px solid #e6ebf5;
      border-right: 1px solid #e6ebf5;

      .input {
        margin-top: 10px;
      }
    }

    .delete-div {
      text-align: center;
      width: 100px;

    }
  }


  .resizable-div {
    position: relative;
    width: 1000px;
    height: 256px;
    margin-top: 30px;

    .image {
      width: 1000px;
      height: 256px;
      position: absolute;
      left: 0;
      top: 0;
      user-select: none;
      margin: 0 auto;
    }

    .draggable {
      position: absolute;
      left: 0;
      top: 0;
    }
  }
}

::v-deep .vue-treeselect__control {
  background: #fafafa !important;
  padding-left: 15px !important;
  width: auto !important;

  .vue-treeselect__control-arrow-container {
    position: relative;
    left: -10px;
  }
}

.my-class {
  border: 1px solid red;
}

.my-class1 {
  border: 1px solid rgb(0, 255, 0);
  ;
}

::v-deep .handle {
  width: 5px !important;
  height: 5px !important;
  background: rgba($color: #ff0000, $alpha: 1) !important;
  border: 0px solid !important;
}

::v-deep .handle-tl {
  top: -5px;
  left: -5px;
  cursor: nw-resize;
}

::v-deep .handle-tm {
  top: -5px;
  left: 50%;
  margin-left: -2.5px;
  cursor: n-resize;
}

::v-deep .handle-tr {
  top: -5px;
  right: -5px;
  cursor: ne-resize;
}

::v-deep .handle-mr {
  right: -5px;
  cursor: e-resize;
}

::v-deep .handle-br {
  bottom: -5px;
  right: -5px;
  cursor: se-resize;
}

::v-deep .handle-bm {
  bottom: -5px;
  left: 50%;
  margin-left: -2.5px;
  cursor: s-resize;
}

::v-deep .handle-bl {
  bottom: -5px;
  left: -5px;
  cursor: sw-resize;
}

::v-deep .handle-ml {
  top: 50%;
  margin-top: -5px;
  left: -5px;
}


::v-deep .handleTwo {
  display: none;
}
</style>
